var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentTemplateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0H6.5C7.05176 0 7.5 0.447998 7.5 1V6C7.5 6.552 7.05176 7 6.5 7H1.5C0.948242 7 0.5 6.552 0.5 6V1C0.5 0.447998 0.948242 0 1.5 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9H6.5C7.05176 9 7.5 9.448 7.5 10V15C7.5 15.552 7.05176 16 6.5 16H1.5C0.948242 16 0.5 15.552 0.5 15V10C0.5 9.448 0.948242 9 1.5 9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0H10.5C9.94824 0 9.5 0.447998 9.5 1V6C9.5 6.552 9.94824 7 10.5 7H15.5C16.0518 7 16.5 6.552 16.5 6V1C16.5 0.447998 16.0518 0 15.5 0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9H15.5C16.0518 9 16.5 9.448 16.5 10V15C16.5 15.552 16.0518 16 15.5 16H10.5C9.94824 16 9.5 15.552 9.5 15V10C9.5 9.448 9.94824 9 10.5 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentTemplateIcon);
export default __webpack_public_path__ + "static/media/ContentTemplateIcon.4c2e422e3189bf39def0d6037b38550b.svg";
export { ForwardRef as ReactComponent };